// extracted by mini-css-extract-plugin
export default {"wrapper":"ServicesPage_wrapper__JF5Je"};